type EventHandler = (key: string, name: string, data?: any) => void

export const eventHandlers: EventHandler[] = []

export const addOnEventHandler = (handler: EventHandler) => {
  eventHandlers.push(handler)
}
